import { Controller } from "@hotwired/stimulus"

// Master enable switch for the hosted stream-overlays feed. Scoped on the
// settings <section> so it owns both the header status pill and the section
// body. Clicking the pill optimistically flips the pill + dims the body
// (300ms), then persists via a background PATCH — no page reload.
export default class extends Controller {
  static targets = ["pill", "ping", "dot", "word", "track", "knob", "body"]
  static values = { enabled: Boolean, url: String }

  toggle() {
    this.enabledValue = !this.enabledValue
    this.render()
    this.persist()
  }

  render() {
    const on = this.enabledValue

    this.pillTarget.setAttribute("aria-checked", on)
    this.pillTarget.classList.toggle("border-[#22C55E]/30", on)
    this.pillTarget.classList.toggle("bg-[#22C55E]/10", on)
    this.pillTarget.classList.toggle("border-app-border-subtle", !on)
    this.pillTarget.classList.toggle("bg-app-surface-alt", !on)
    this.pillTarget.classList.toggle("hover:bg-app-surface-hover", !on)

    this.pingTarget.classList.toggle("hidden", !on)
    this.dotTarget.classList.toggle("bg-[#22C55E]", on)
    this.dotTarget.classList.toggle("bg-app-text-faint", !on)

    this.wordTarget.textContent = on ? "Live" : "Paused"
    this.wordTarget.classList.toggle("text-[#22C55E]", on)
    this.wordTarget.classList.toggle("text-app-text-muted", !on)

    this.trackTarget.classList.toggle("bg-vivid-purple", on)
    this.trackTarget.classList.toggle("bg-app-surface-active", !on)
    this.knobTarget.classList.toggle("translate-x-[16px]", on)

    if (this.hasBodyTarget) {
      this.bodyTarget.style.opacity = on ? "" : "0.4"
      this.bodyTarget.style.pointerEvents = on ? "" : "none"
      this.bodyTarget.style.userSelect = on ? "" : "none"
    }
  }

  persist() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": token || "",
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: `paused=${this.enabledValue ? "0" : "1"}`,
    }).catch(() => {})
  }
}
